import { t } from 'i18next';
import { ObjectSchema } from 'yup';
import { PhoneCountryCodeType } from '@bus/models';
import { GenderEnum, ResidentialStatusEnum, TitleEnum } from '../../../../types/forms';
import { DirectorPersonFormModel_OB_OL } from './formModel';
import { getEnumValues } from '../../../../services/common/miscUtils';
import Yup, { minMobileNumberLength, maxMobileNumberLength, regExEmail } from '../../../../services/common/validation';

export const getValidationSchema = (): ObjectSchema<Partial<DirectorPersonFormModel_OB_OL>> => {
  return Yup.object({
    title: Yup.string().required(t('validation:required')).oneOf(getEnumValues(TitleEnum)),
    firstName: Yup.string().requiredWithMsg().unaccentedLetters().lengthBetween(0, 64),
    lastName: Yup.string().requiredWithMsg().unaccentedLetters().lengthBetween(0, 64),
    middleName: Yup.string().unaccentedLetters().lengthBetween(0, 64),
    gender: Yup.string().requiredWithMsg().oneOf(getEnumValues(GenderEnum)),
    dateOfBirth: Yup.string().requiredWithMsg(),
    countryCode: Yup.string().requiredWithMsg().oneOf(getEnumValues(PhoneCountryCodeType)),
    mobileNumber: Yup.string().requiredWithMsg().lengthBetween(minMobileNumberLength, maxMobileNumberLength),
    email: Yup.string().requiredWithMsg().matches(regExEmail, t('validation:invalidEmail')),
    residentialStatus: Yup.string().requiredWithMsg().oneOf(getEnumValues(ResidentialStatusEnum)),
  });
};
